import React, { ReactElement, } from 'react';
import { BoxProps, } from '@material-ui/core/Box';
import { curry, } from 'ramda';

/**
 * Use this wrapper if on base element you defined props for example:
 * <Box component={BoxComponentWrapper(<Grid container
 *                                           direction="row"
 *                                           justify="space-between"
 *                                           alignItems="center" />)}
 *      px={2}>
 */
const BoxComponentWrapper = curry((component: ReactElement, props: BoxProps) => React.cloneElement(component, props));

export default BoxComponentWrapper;
